
const isDestinationDeletable = (destination) => !destination?.trackers?.length

export default isDestinationDeletable;